import { BaseClient } from '../BaseClient';
import { Empty } from '../compiled-protos/common';
import {
  QBClassMapping,
  QBClassMappingList,
  QBCreateClassMappingRequest,
  QBCreateCustomerMappingRequest,
  QBCreateItemMappingRequest,
  QBCustomerMapping,
  QBCustomerMappingList,
  QBDeleteClassMappingRequest,
  QBDeleteCustomerMappingRequest,
  QBDeleteItemMappingRequest,
  QBDiscoverClassesResponse,
  QBDiscoverItemsRequest,
  QBDiscoverItemsResponse,
  QBItemMapping,
  QBItemMappingList,
  QBListQBOCustomersRequest,
  QBListQBOCustomersResponse,
} from '../compiled-protos/quickbooks';
import { QuickBooksServiceClient } from '../compiled-protos/quickbooks.client';

class QuickBooksServiceWrapper extends BaseClient {
  self: QuickBooksServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new QuickBooksServiceClient(this.transport);
  }

  public async DiscoverQBOItems(req: QBDiscoverItemsRequest) {
    let res = QBDiscoverItemsResponse.create();
    try {
      res = await this.self.discoverQBOItems(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async CreateItemMapping(req: QBCreateItemMappingRequest) {
    let res = QBItemMapping.create();
    try {
      res = await this.self.createItemMapping(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async ListItemMappings() {
    let res = QBItemMappingList.create();
    try {
      res = await this.self.listItemMappings(Empty.create(), this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async DeleteItemMapping(req: QBDeleteItemMappingRequest) {
    try {
      await this.self.deleteItemMapping(req, this.getMetaData()).response;
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  public async ListQBOCustomers(req: QBListQBOCustomersRequest) {
    let res = QBListQBOCustomersResponse.create();
    try {
      res = await this.self.listQBOCustomers(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async CreateCustomerMapping(req: QBCreateCustomerMappingRequest) {
    let res = QBCustomerMapping.create();
    try {
      res = await this.self.createCustomerMapping(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async ListCustomerMappings() {
    let res = QBCustomerMappingList.create();
    try {
      res = await this.self.listCustomerMappings(Empty.create(), this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async DeleteCustomerMapping(req: QBDeleteCustomerMappingRequest) {
    try {
      await this.self.deleteCustomerMapping(req, this.getMetaData()).response;
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  public async DiscoverQBOClasses() {
    let res = QBDiscoverClassesResponse.create();
    try {
      res = await this.self.discoverQBOClasses(Empty.create(), this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async CreateClassMapping(req: QBCreateClassMappingRequest) {
    let res = QBClassMapping.create();
    try {
      res = await this.self.createClassMapping(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async ListClassMappings() {
    let res = QBClassMappingList.create();
    try {
      res = await this.self.listClassMappings(Empty.create(), this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return res;
    }
    return res;
  }

  public async DeleteClassMapping(req: QBDeleteClassMappingRequest) {
    try {
      await this.self.deleteClassMapping(req, this.getMetaData()).response;
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
}

export {
  QuickBooksServiceWrapper as QuickBooksService,
  QBDiscoverItemsRequest,
  QBDiscoverItemsResponse,
  QBCreateItemMappingRequest,
  QBDeleteItemMappingRequest,
  QBItemMapping,
  QBItemMappingList,
  QBListQBOCustomersRequest,
  QBListQBOCustomersResponse,
  QBCreateCustomerMappingRequest,
  QBCustomerMapping,
  QBCustomerMappingList,
  QBDeleteCustomerMappingRequest,
  QBCreateClassMappingRequest,
  QBClassMapping,
  QBClassMappingList,
  QBDeleteClassMappingRequest,
};
